export default __webpack_public_path__ + "static/media/photo1.6aa3c943.jpg";